export default __webpack_public_path__ + "static/media/customs-sync-icon.d8a7c6fc.svg";